import { atom } from 'jotai';

import { type UserProfileLanguageTypeDto } from '@/api/generated/models/user-profile-language-type-dto';
export type UserProfileLanguageAtomModel = {
  availableLanguages: UserProfileLanguageTypeDto[];
  currentLanguage?: UserProfileLanguageTypeDto;
  defaultLanguage?: UserProfileLanguageTypeDto;
  shouldClear: boolean;
};

export const emptyUserProfileLanguageAtom: UserProfileLanguageAtomModel = {
  availableLanguages: [],
  shouldClear: true,
};

export const UserProfileLanguageAtom = atom<UserProfileLanguageAtomModel>(
  emptyUserProfileLanguageAtom,
);

export const IsUserProfileDefaultLanguageAtom = atom<boolean>(
  get =>
    get(UserProfileLanguageAtom).defaultLanguage === get(UserProfileLanguageAtom).currentLanguage,
);
